import { Input, Text } from "@ttc3k/trekker";
import { Shop } from "iconoir-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { WhereaboutsModal } from "shared/components";
import { Flex } from "styled-system/jsx";

type CreateMembershipCheckoutModalProps = {
  isOpen: boolean;
  onClose: () => void;
  defaultName: string;
  tierName: string;
  targetIsTest: boolean;
  loading: boolean;
  onCreate: (values: { name: string; price: number }) => void;
  membershipTranslationValues: Record<string, string>;
};

export const CreateMembershipCheckoutModal = ({
  isOpen,
  onClose,
  defaultName,
  tierName,
  targetIsTest,
  loading,
  onCreate,
  membershipTranslationValues,
}: CreateMembershipCheckoutModalProps) => {
  const { t } = useTranslation("home", {
    keyPrefix: "VIEWS.SETTINGS.VIEWS.MEMBERSHIP_TIERS.PAYMENT.MODAL",
  });
  const [name, setName] = useState(defaultName);
  const [price, setPrice] = useState("");

  useEffect(() => {
    if (isOpen) {
      setName(defaultName);
      setPrice("");
    }
  }, [isOpen, defaultName]);

  const priceNumber = Number(price);
  const isValid =
    name.trim().length > 0 &&
    price !== "" &&
    Number.isFinite(priceNumber) &&
    priceNumber >= 0;

  return (
    <WhereaboutsModal
      isOpen={isOpen}
      onClose={onClose}
      title={t("TITLE", { ...membershipTranslationValues, tier: tierName })}
      description={t(
        targetIsTest ? "DESCRIPTION_TEST" : "DESCRIPTION_LIVE",
        membershipTranslationValues,
      )}
      HeaderIcon={Shop}
      size="md"
      saveButtonCopy={t("CREATE")}
      cancelButtonCopy={t("CANCEL")}
      saveButtonProps={{
        visual: "accent.blue",
        disabled: !isValid || loading,
        isLoading: loading,
        onClick: () => onCreate({ name: name.trim(), price: priceNumber }),
      }}
      cancelButtonProps={{ onClick: onClose }}
      isMaxZIndex
    >
      <Flex flexDir="column" gap="300">
        <Input
          label={t("NAME")}
          value={name}
          disabled={loading}
          onChange={e => setName(e.target.value)}
        />
        <Input
          label={t("PRICE")}
          type="number"
          min={0}
          step="0.01"
          value={price}
          disabled={loading}
          onChange={e => setPrice(e.target.value)}
        />
        <Text visual="smallRegular" color="text.mid">
          {t("HINT", membershipTranslationValues)}
        </Text>
      </Flex>
    </WhereaboutsModal>
  );
};
